import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpBackend) // Per caricare i file di traduzione
  .use(LanguageDetector) // Per rilevare automaticamente la lingua dal browser
  .use(initReactI18next) // Per integrare con React
  .init({
    // lng: 'IT', // This sets the initial language to Italian
    fallbackLng: 'it', // If a translation is not available in the chosen language, fallback to Italian
    supportedLngs: ['en', 'it'], // Lingue supportate
    // Optional: Configure how to load translation files (this example uses HTTP Backend)
    backend: {
      loadPath: '/locales/{{lng}}/translation.json', // Path to translation files
    },
    debug: true, // Log di debug
    interpolation: {
      escapeValue: false, // React si occupa già dell'escaping
    },
	detection: {
    order: ['querystring', 'cookie', 'localStorage', 'navigator'],
    caches: ['cookie'], // Memorizza la lingua nei cookie
    },
  });

export default i18n;